import React, { useState } from 'react';
import { Paper, Grid, Dialog, DialogContent, DialogActions, DialogTitle, Typography, IconButton, Button, TextField, Select, MenuItem, FormControl, InputLabel } from "@mui/material";
import CloseIcon from '@mui/icons-material/Close';
import Relatorio from './Relatorio';
import api from '../service/Api';
import DeleteOutlineOutlinedIcon from '@mui/icons-material/DeleteOutlineOutlined';
import SaveOutlinedIcon from '@mui/icons-material/SaveOutlined';
import DoDisturbOutlinedIcon from '@mui/icons-material/DoDisturbOutlined';
import EditOutlinedIcon from '@mui/icons-material/EditOutlined';
import { useSnackbar } from 'notistack';

export default function Processo({ open, handleClose, processo }) {
    const [editable, setEditable] = useState(false);
    const [editedProcesso, setEditedProcesso] = useState(processo);
    const [openRelatorio, setOpenRelatorio] = useState(false);
    const { enqueueSnackbar } = useSnackbar();

    const handleEdit = () => {
        setEditable(true);
    };

    const handleSave = async () => {
        try {
            await api.put(`api/processos/${editedProcesso.id}`, editedProcesso);
            enqueueSnackbar('Processo atualizado com sucesso', { variant: 'success', anchorOrigin: { vertical: 'top', horizontal: 'center' } });
            setTimeout(() => {
                handleClose();
                window.location.reload();
            }, 3000);
        } catch (error) {
            enqueueSnackbar('Erro ao editar processo!', { variant: 'error', anchorOrigin: { vertical: 'top', horizontal: 'center' } });
        }
    };

    const handleCancel = () => {
        setEditable(false);
        setEditedProcesso(processo);
    };

    const handleChange = (field, value) => {
        setEditedProcesso(prevState => ({
            ...prevState,
            [field]: value
        }));
    };

    const handleDelete = async () => {
        try {
            await api.delete(`api/processos/${editedProcesso.id}`);
            enqueueSnackbar('Processo deletado com sucesso!', { variant: 'info', anchorOrigin: { vertical: 'top', horizontal: 'center' } });
            setTimeout(() => {
                handleClose();
                window.location.reload();
            }, 3000);
        } catch (error) {
            enqueueSnackbar('Erro ao deletar processo!', { variant: 'error', anchorOrigin: { vertical: 'top', horizontal: 'center' } });
        }
    };

    const handleOpenReport = () => {
        setOpenRelatorio(true);
    };

    const handleCloseRelatorio = () => {
        setOpenRelatorio(false);
    };

    return (
        <Dialog open={open} onClose={handleClose} fullWidth maxWidth="md">
            <DialogTitle>
                <Grid container justifyContent="space-between" alignItems="center">
                    <Typography variant="h6">Detalhes do Processo</Typography>
                    <IconButton edge="end" color="inherit" onClick={handleClose} aria-label="close">
                        <CloseIcon />
                    </IconButton>
                </Grid>
            </DialogTitle>
            <DialogContent dividers>
                <Paper elevation={3} style={{ padding: '16px', marginBottom: '16px' }}>
                    <Grid container spacing={2}>
                        <Grid item xs={12}>
                            <Typography variant="h6">Informações do Processo</Typography>
                        </Grid>
                        {[
                            { label: "Nome", field: "processo" },
                            { label: "Descrição", field: "descricao" },
                            { label: "Atividade", field: "atividade" },
                            { label: "Finalidade", field: "finalidade" },
                            // { label: "Áreas Selecionadas", field: "areas_selecionadas_nome" },
                            // { label: "Áreas com Acesso", field: "areas_com_acesso_nome" },
                            // { label: "Responsável", field: "responsavel_nome" },
                            { label: "RIPD", field: "ripd" },
                            { label: "Riscos", field: "riscos" },
                            { label: "Classificação de Riscos", field: "classificacao_riscos" },
                            { label: "Dados Armazenados", field: "armazenados" },
                            { label: "Descrição dos Dados Armazenados", field: "armazenados_texto" },
                            { label: "Armazenamento", field: "armazenamento" },
                            { label: "Dados Pessoais Tratados", field: "dados_pessoais_tratados", isArray: true },
                            { label: "Dados Sensíveis", field: "dados_sensiveis", isBoolean: true },
                            { label: "Descrição dos Dados Sensíveis", field: "desc_sensiveis" },
                            { label: "Dados de Menores", field: "dados_menor", isBoolean: true },
                            { label: "Descrição dos Dados de Menores", field: "desc_dados_menor" },
                            { label: "Dados Sensíveis de Menores", field: "dados_menor_sensiveis", isBoolean: true },
                            { label: "Descrição dos Dados Sensíveis de Menores", field: "desc_dados_menor_sensiveis" },
                            { label: "Compartilhamento Externo", field: "compartilhamento_externo", isBoolean: true },
                            { label: "Terceirizados", field: "compartilhamento_externo_terceirizados" },
                            { label: "Transferência Internacional", field: "transferencia_internacional", isBoolean: true },
                            { label: "Detalhes da Transferência Internacional", field: "transferencia_internacional_text" },
                            { label: "Ações", field: "acoes" },
                            { label: "Base Legal", field: "bases", isArray: true }
                        ].map(({ label, field, isArray, isBoolean }) => (
                            <Grid item xs={12} key={field}>
                                {isBoolean ? (
                                    <FormControl fullWidth>
                                        <InputLabel>{label}</InputLabel>
                                        <Select
                                            value={editedProcesso[field] ? 'true' : 'false'}
                                            disabled={!editable}
                                            onChange={(e) => handleChange(field, e.target.value === 'true')}
                                        >
                                            <MenuItem value="true">Sim</MenuItem>
                                            <MenuItem value="false">Não</MenuItem>
                                        </Select>
                                    </FormControl>
                                ) : (
                                    <TextField
                                        fullWidth
                                        label={label}
                                        value={isArray ? editedProcesso[field].join(', ') : editedProcesso[field]}
                                        disabled={!editable}
                                        onChange={(e) => handleChange(field, isArray ? e.target.value.split(', ') : e.target.value)}
                                    />
                                )}
                            </Grid>
                        ))}
                    </Grid>
                </Paper>
            </DialogContent>
            <DialogActions>
                {!editable ? (
                    <>
                        <Button onClick={handleEdit} variant='contained' color="primary">
                            <EditOutlinedIcon />
                        </Button>
                        <Button onClick={handleDelete} variant='contained' color="error">
                            <DeleteOutlineOutlinedIcon />
                        </Button>
                        <Button onClick={() => handleOpenReport(processo)} variant='contained' color="primary">
                            Relatório
                        </Button>
                        <Relatorio open={openRelatorio} handleClose={handleCloseRelatorio} processo={processo} />
                    </>
                ) : (
                    <>
                        <Button onClick={handleCancel} variant='contained' color="secondary">
                            Cancelar <DoDisturbOutlinedIcon />
                        </Button>
                        <Button onClick={handleSave} variant='contained' color="primary">
                            Salvar <SaveOutlinedIcon />
                        </Button>
                    </>
                )}
            </DialogActions>
        </Dialog>
    );
}
